"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var services_1 = require("../../services");
var UserMenuComponent = (function () {
    function UserMenuComponent(localizationService, userService, eventService, storageService) {
        this.localizationService = localizationService;
        this.userService = userService;
        this.eventService = eventService;
        this.storageService = storageService;
        this.interfaceLocals = {};
    }
    UserMenuComponent.prototype.shouldHideDropdown = function ($event) {
        if (!$event.target.closest('.js-wrapper-dropdown') || $event.target.classList.contains('js-dropdown-logout')) {
            this.stateActiveDropdown = false;
            this.eventService.fire('hidePacksBoxLayout');
        }
    };
    UserMenuComponent.prototype.changeBackUrl = function () {
        this.burl = encodeURIComponent("/" + this.localizationService.currentLang + "/game/packs");
        //this.burl = encodeURIComponent(location.pathname);
    };
    UserMenuComponent.prototype.ngOnInit = function () {
        this.renderInterfaceLocals();
        this.subscribeOnEvents();
    };
    UserMenuComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    UserMenuComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionChangeLocalsEvent = this.eventService.subscribe('changeLocals', function () {
            _this.renderInterfaceLocals();
        });
    };
    UserMenuComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionChangeLocalsEvent.unsubscribe();
    };
    UserMenuComponent.prototype.toggleDropdown = function () {
        if (this.userService.authorized) {
            this.stateActiveDropdown = !this.stateActiveDropdown;
            if (this.stateActiveDropdown) {
                this.eventService.fire('showPacksBoxLayout');
            }
            else {
                this.eventService.fire('hidePacksBoxLayout');
            }
        }
    };
    UserMenuComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
            _this.currentLang = _this.localizationService.currentLang;
            _this.changeBackUrl();
        });
    };
    return UserMenuComponent;
}());
__decorate([
    core_1.HostListener('document:click', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserMenuComponent.prototype, "shouldHideDropdown", null);
UserMenuComponent = __decorate([
    core_1.Component({
        selector: 'user-menu-component',
        template: require('./user-menu.component.pug'),
        styles: [require('./user-menu.component.scss')]
    }),
    __metadata("design:paramtypes", [services_1.LocalizationService,
        services_1.UserService,
        services_1.EventService,
        services_1.StorageService])
], UserMenuComponent);
exports.UserMenuComponent = UserMenuComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/user-menu/user-menu.component.ts
// module id = 252
// module chunks = 0